import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, Table, TableHead, TableRow, TableCell, TableBody,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import React, {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {
    useAddStudentToVirtualGroupMutation,
    useEditVirtualGroupMutation,
    useVirtualGroupDetailsQuery
} from "../store/virtualgroup/virtualGroupApi";
import IconButton from "@mui/material/IconButton";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import {PersonRemove, RemoveFromQueue, RemoveSharp} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useGetGroupsOfEmployeeDisciplineQuery} from "../store/employee/employeeApi";
import {useGetStudentsDetailsOfGroupFlowBindingQuery} from "../store/journal/journalApi";
import copyObject from "../utils/copyObject";

export default function EditVirtualGroupPage() {
    const {id} = useParams();
    const [refresh, setRefresh] = useState(false);
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [totalHours, setTotalHours] = useState(0);
    const {data} = useVirtualGroupDetailsQuery(id);
    const [copyOfStudents, setCopyOfStudents] = useState([]);
    const [studentsForRemoval, setStudentsForRemoval] = useState([]);
    const [editVirtualGroupRequest] = useEditVirtualGroupMutation();
    const [showAddStudentBar, setShowAddStudentBar] = useState(false);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [studentFilter, setStudentFilter] = useState('');
    const [saveRequest] = useAddStudentToVirtualGroupMutation();
    const [groups, setGroups] = useState([]);
    const [students, setStudents] = useState([]);
    const [disciplineData, setDisciplineData] = useState({
        disciplineId: null,
        lessonType: null
    });
    
    const {data: groupData} = useGetGroupsOfEmployeeDisciplineQuery({
        disciplineId: disciplineData.disciplineId,
        lessonType: disciplineData.lessonType
    });
    
    const {data: studentsData} = useGetStudentsDetailsOfGroupFlowBindingQuery({
        disciplineId: disciplineData.disciplineId,
        lessonType: disciplineData.lessonType,
        groupId: selectedGroupId
    });

    useEffect(() => {
        if (!data?.data)
            return;

        setGroupName(data.data.virtualGroupName);
        setTotalHours(data.data.totalHours);
        setDisciplineData({
            disciplineId: data.data.disciplineId,
            lessonType: data.data.lessonTypeId
        });
        setCopyOfStudents(copyObject(data.data.students));
        
        if (groupData?.data)
            setGroups(copyObject(groupData?.data));
        
        if (studentsData?.data)
            setStudents(copyObject(studentsData?.data));
    }, [data, groupData, studentsData]);

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date) {
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsSaving(true);
        const request = {
            newName: groupName,
            virtualGroupId: id,
            totalHours,
            studentsForRemoval: studentsForRemoval.map((item) => {
                return parseInt(item.key, 10)
            })
        };
        
        console.log(request)
        
        await editVirtualGroupRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                navigate('/');
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                setIsSaving(false);
            }
        }).catch(() => {
            setIsSaving(false);
        });
    };

    async function addStudentToSubGroup(student) {
        // console.log(student);
        const studentId = student.studentId;
        const virtualGroupId = id;
        const request = {
            studentId,
            virtualGroupId
        };

        setIsSaving(true);
        await saveRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Сохранено. Студент добавлен в сводную группу');
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
            
            setIsSaving(false);
        }).catch(() => {
            setIsSaving(false);
        });
    }

    function handleGroupChange(event) {
        const value = event.target.value;
        setSelectedGroupId(value.key);
        setSelectedGroup(value);
    }
    
    function showStudentBar() {
        setShowAddStudentBar(true);
    }
    
    return (
        <GeneralLayout>
            <PageTitle title={`Редактировать сводную группу`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress/> : <></>}
                            Редактировать сводную группу {data?.data?.virtualGroupName}
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                    <Typography><strong>Наименование</strong></Typography>
                                    <TextField size={'small'}
                                               onInput={(event) => {
                                                   setGroupName(event.target.value)
                                               }}
                                               value={groupName}/>
                                </Stack>

                                <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                    <Typography><strong>Часы</strong></Typography>
                                    <TextField size={'small'}
                                               onInput={(event) => {
                                                   setTotalHours(event.target.value)
                                               }}
                                               value={totalHours}/>
                                </Stack>
                                
                                <Typography variant={'subtitle1'}>Студенты <IconButton onClick={() => {showStudentBar()}}><AddIcon /></IconButton></Typography>

                                {showAddStudentBar
                                ? <Card>
                                    <CardContent>
                                        <Stack spacing={1}>
                                            <FormControl size={"small"} fullWidth>
                                                <InputLabel id="group-label">Группа</InputLabel>
                                                <Select
                                                    labelId="group-label"
                                                    id="group-select"
                                                    value={selectedGroup}
                                                    label="Группа"
                                                    onChange={(event) => handleGroupChange(event)}
                                                >
                                                    {groups.sort((left, right) => left.value > right.value ? 1 : -1)
                                                        .map((item) => {
                                                            return <MenuItem value={item} key={item.value}>{item.value}</MenuItem>
                                                        })}
                                                </Select>
                                            </FormControl>

                                            <TextField size={"small"}
                                                       placeholder={"Поиск по ФИО студента"}
                                                       onInput={(event) => setStudentFilter(event.target.value)}
                                                       disabled={selectedGroupId === null || selectedGroupId === undefined}/>

                                            <Table size={"small"}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>ФИО студента</TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {students?.filter((item) => item.fullName.toLowerCase().startsWith(studentFilter))
                                                        .map((item) => {
                                                            return <TableRow>
                                                                <TableCell>{item.fullName}</TableCell>
                                                                <TableCell>
                                                                    {item.attachedToEmployee !== null && item.attachedToEmployee !== undefined && item.attachedToEmployee.length > 0
                                                                        ? <small>{`Уже в подгруппе "${item.attachedToSubGroup}" преподавателя ${item.attachedToEmployee}`}</small>
                                                                        : <Button size={"small"}
                                                                                  startIcon={!item.accepted ? <AddIcon /> : <RemoveSharp />}
                                                                                  onClick={(event) => addStudentToSubGroup(item)}
                                                                                  disabled={selectedGroupId === null || selectedGroupId === undefined || isSaving}>
                                                                            {item.accepted ? 'Убрать из группы' : 'Добавить в группу'}
                                                                        </Button>}
                                                                </TableCell>
                                                            </TableRow>
                                                        })}
                                                </TableBody>
                                            </Table>
                                        </Stack>
                                    </CardContent>
                                </Card>
                                : <></>}
                                
                                <ol>
                                    {copyOfStudents?.sort((left, right) => left.value > right.value ? 1 : -1).map((student) => {
                                        return <li>{student.value} <IconButton color={'error'}
                                                                               disabled={studentsForRemoval.find((item) => item === student) !== undefined}
                                                                               onClick={() => {
                                                                                   studentsForRemoval.push(student);
                                                                                   applyVisualChanges();
                                                                               }}
                                                                               size={'small'}><PersonRemove/></IconButton>
                                        </li>
                                    })}
                                </ol>


                                <Stack justifyContent="space-between">
                                    {
                                        !isSaving
                                            ? <Button variant="contained"
                                                      disabled={data === null || data === undefined}
                                                      onClick={handleSave}>Сохранить</Button>
                                            : <CircularProgress/>
                                    }

                                    <Typography fontSize={'small'} align={'center'}>Обратите внимание, что после
                                        удаления студента из сводной группы нельзя будет по нему просмотреть историю
                                        посещений занятий, заполненных в рамках данной сводной группы</Typography>
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>
                    
                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}